class Validaciones {
  static float(valor: string, cantidadDecimales: number): boolean {
    if (valor === '0') {
      return true
    }
    const patron: RegExp = new RegExp(`^\\d+(\\.\\d{1,${cantidadDecimales}})?$`)
    const numeroString: string = valor.replace(',', '.')
    const numero: number = parseFloat(numeroString)
    if (!numero) {
      return false
    }

    return patron.test(numeroString)
  }

  static int(valor: string): boolean {
    if (valor === '0') {
      return true
    }
    const patron: RegExp = new RegExp(/^\d+$/)
    const numero: number = parseInt(valor, 10)
    if (!numero) {
      return false
    }

    return patron.test(valor)
  }

  static isNullOrEmptyString(str: string | null | undefined): boolean {
    return !str || str.trim().length === 0
  }

  static esFechaValida(valor: string): boolean {
    const dateRegex =
      /^(0[1-9]|[12][0-9]|3[01])[-](0[1-9]|1[012])[-](19|20)\d\d$/
    return dateRegex.test(valor)
  }

  static esLetrasNumeros(valor: string): boolean {
    const dateRegex = new RegExp(/^[a-zA-Zá-úÁ-Ú0-9,.\s]+$/)
    const isValid = dateRegex.test(valor)
    return isValid
  }

  static isDireccion(valor: string): boolean {
    if (valor === '') return true;
    const dateRegex = /^[a-zA-Zá-úÁ-Ú0-9\s.,#\/\-°º'()]+$/;
    return dateRegex.test(valor);
  }

  static letrasNumerosGuionGuionBajo(valor: string): boolean {
    if (valor === '') return true;
    const dateRegex = new RegExp(/^[a-zA-Zá-úÁ-Ú0-9,.\s_-]+$/)
    return dateRegex.test(valor);
  }
  static soloLetrasYPuntuacion(valor: string): boolean {

    if (valor === '')
      return true;
    
    const dateRegex = new RegExp(/^[a-zA-Zá-úÁ-Ú0-9,.&#-\s]+$/)
    const isValid = dateRegex.test(valor)
    return isValid
  }

  static soloLetras(valor: string): boolean {

    if (valor === '')
        return true;
    // Letras, tildes, Ñ/ñ, Ü/ü, espacios, guion y apostrofe
    const regex = /^[A-Za-zÁÉÍÓÚáéíóúÑñÜü\s'-]+$/;

    return regex.test(valor);
}

  static soloDigitos(valor: number): boolean {

    const cadenaDigitos = valor.toString();

    const dateRegex = new RegExp(/^[0-9]+$/)
    const isValid = dateRegex.test(cadenaDigitos)
    return isValid
  }

  static esValidoEmail(valor: string): boolean {
    if (valor === '')
      return true;

    const dateRegex = new RegExp(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i)
    const isValid = dateRegex.test(valor)
    return isValid
  }

  static esMayor18Anios(value: Date | null): boolean {
    if (!value) return true;

    const hoy = new Date();
    const fechaLimite = new Date(
      hoy.getFullYear() - 18,
      hoy.getMonth(),
      hoy.getDate()
    ); // Calcula la fecha de hace 18 años

    return value <= fechaLimite;
  }
}

export default Validaciones
